//The module wraps up the basic CRUD operations to interact with the server
//The Url parameter should includes all the parameters required to retrieve data from the server
//and they can be added to relevant functions in the service layer
//
import Axios from 'axios'

//
//Post data to server by POST method with authorization token
//
async function postData(url, data) {
    try {
        let response = await Axios.post(url, data);
        return response.data;
    }
    catch (err) {
        throw err;
    }
    
}

async function postDataWithToken(url, data, token) {
    try {

        let axios = Axios.create({
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        let response = await axios.post(url, data);
        console.log(response);
        return response.data;

    }
    catch (err) {
        throw err;
    }
}

export default {
    postData,
    postDataWithToken
}